module.exports = __webpack_public_path__ + "static/media/top-right-2.99ff0335.svg";